import { StudentStatus } from '../enums/student-status.enum'

export const ActiveStudentStatuses = [
  StudentStatus.APPLIED,
  StudentStatus.REAPPLIED,
  StudentStatus.ACCEPTED,
  StudentStatus.PENDING,
  StudentStatus.ACTIVE,
]
